import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import {
    fetchTransactionDetails as fetchTransactionDetailsAction,
    replaceTransactionDetails,
    setTransactionDetailsError,
} from '@perpay-web/fintech/actions/entities/transactionDetails';
import { TRANSACTION_DETAILS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { getStandardResultsSetPaginatedEndpoint } from '@perpay-web/fintech/epics/utils/pagination';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';

export const fetchTransactionDetails = (action$, state$, { get }) =>
    action$.pipe(
        ofType(fetchTransactionDetailsAction().type),
        mergeMap((action) => {
            const { payload } = action;

            return get(
                getStandardResultsSetPaginatedEndpoint({
                    endpoint: TRANSACTION_DETAILS_ENDPOINT,
                    pageSize: payload.pageSize,
                    pageNumber: payload.pageNumber,
                }),
            );
        }),
        mergeMap((results) => [replaceTransactionDetails(results.response)]),
        handleErrorMessageWithFallback((error) => [
            setTransactionDetailsError(error),
        ]),
    );
